module.exports = __webpack_public_path__ + "5c90b692da4b1ff42772a377b9e6a1f2.pdf";